'use strict';

/**
 * Thumbs gallery
 */

const $thumbs = $('.thumbs A');

$thumbs.click(function (ev) {
    ev.preventDefault();

    const index = $(this).data('index');

    // Hide all other pictures and show selected
    $('#slideshow .js-photo').hide();
    const picture = $(`#slideshow .js-photo-${index}`);

    if (picture.find('IMG').length < 1) {
        // Load img into picture container
        picture.append(`<img src="${$(this).attr('data-thumb')}" alt="${$(this).attr('title')}" />`);
    }

    picture.show();

    // Select current photo in a list
    $('.thumbs LI').removeClass('selected');
    $(this).parents('LI').addClass('selected');
});

// Show more thumbs
$('.thumbs-more').click(function (ev) {
    ev.preventDefault();

    const thumbs = $('.picture_block UL.thumbs');
    thumbs.toggleClass('thumbs-heigh');

    const isToggled = thumbs.is('.thumbs-heigh');

    $(this).text(isToggled ? trans('good.hide_more_thumbs') : trans('good.show_more_thumbs'));

    if (isToggled) {
        tracker.track('Страница товара => Нажатие "еще фото"', {url: document.baseURI});
    }
});
